'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface FooterLink {
  label: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const footerSections: FooterSection[] = [
    {
      title: 'Solutions',
      links: [
        { label: 'Sferal.ai Platform', href: '/solutions-overview' },
        { label: 'AIDoo Assist', href: '/solutions-overview' },
        { label: 'AIDoo Analyzer', href: '/solutions-overview' },
        { label: 'Implementation Services', href: '/solutions-overview' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { label: 'AI Readiness Assessment', href: '/ai-readiness-assessment' },
        { label: 'Results & Case Studies', href: '/results-and-roi' },
        { label: 'Request Consultation', href: '/partnership-inquiry' }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Mindshift AI', href: '/homepage' },
        { label: 'Regional Authority', href: '/homepage' },
        { label: 'Partnership Inquiry', href: '/partnership-inquiry' },
        { label: 'Contact Us', href: '/partnership-inquiry' }
      ]
    }
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-secondary text-white ${className}`}>
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <span className="text-xl font-display font-semibold">
                Mindshift AI
              </span>
            </div>
            <p className="text-white/80 text-sm mb-6 leading-relaxed">
              Your exclusive regional partner for enterprise AI governance and orchestration in Australia and New Zealand.
            </p>
            <div className="flex items-center space-x-2 text-sm text-white/80">
              <Icon name="MapPinIcon" size={16} className="text-accent" />
              <span>Australia & New Zealand</span>
            </div>
          </div>
          
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-display font-semibold text-white mb-4">
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      href={link.href}
                      className="text-white/80 text-sm hover:text-accent transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm">
              &copy; {currentYear} Mindshift AI. All rights reserved.
            </p>
            
            <div className="flex items-center space-x-6">
              <Link href="/homepage" className="text-white/60 text-sm hover:text-accent transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link href="/homepage" className="text-white/60 text-sm hover:text-accent transition-colors duration-300">
                Terms of Service
              </Link>
              <Link href="/homepage" className="text-white/60 text-sm hover:text-accent transition-colors duration-300">
                Compliance
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;